import initRoadmap from 'ee/roadmap/roadmap_bundle';

initRoadmap();
